









































import AudioFileAlbumCategoryRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MusicService/AudioFileAlbumCategoryRequest";
import AudioFileAlbumCategoryResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MusicService/AudioFileAlbumCategoryResponse";
import ChangeSortIndexRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/ChangeSortIndexRequest";
import SortIndexRequest from "@/api/dataSource/api/Spirit/Common/Helpers/Models/SortIndexRequest";
import { MUSIC_CATEGORY_CREATE, MUSIC_CATEGORY_EDIT } from "@/route-names";
import { DragLiModel } from "@components/ui/models";
import EventBus from "@models/eventBus";
import TranslationItemModel from "@models/translationItemModel";
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";

@Component
export default class MusicCategoriesPage extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  getDataFunc = this.$api.MusicService.getCategoriesAsync.bind(
    this.$api.MusicService
  );
  removeFunc = this.$api.MusicService.deleteCategoryAsync.bind(
    this.$api.MusicService
  );
  columnNames = ["#", "Название", "", ""];
  createRouteName = MUSIC_CATEGORY_CREATE;
  editRouteName = MUSIC_CATEGORY_EDIT;
  async startDelete(item: AudioFileAlbumCategoryResponse) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }

  /**
   * * Получить список для изменения порядка
   */
  async getList() {
    let self = this;
    return new Promise<Array<DragLiModel>>(async (resolve) => {
      await self.$api.MusicService.getCategoriesAsync(
        new AudioFileAlbumCategoryRequest()
      ).then((response) => {
        if (response.Items) {
          return resolve(
            response.Items.map(
              (x, index) =>
                new DragLiModel({
                  Id: x.Id,
                  SortIndex: index + 1,
                  Translate: x.Translations.map(
                    (t) =>
                      new TranslationItemModel({
                        langCode: t.LangCode,
                        name: t.Name,
                      })
                  ),
                })
            )
          );
        } else {
          return resolve(null);
        }
      });
    });
  }

  /**
   * * Изменить порядковый индекс
   * @param items Список с измененными индексами
   */
  async changeSortIndex(items: Array<DragLiModel>) {
    let self = this;
    return new Promise<boolean>(async (resolve) => {
      await self.$api.MusicService.changeSortIndexAsync(
        new ChangeSortIndexRequest({
          SortIndices: items.map(
            (x) =>
              new SortIndexRequest({
                Id: Number(x.Id),
                SortIndex: x.SortIndex,
              })
          ),
        })
      ).then((result) => {
        if (result) {
          this.$notification.success("Порядок успешно изменен.");
        }
        return resolve(true);
      });
    });
  }
}
